export default "__VITE_ASSET__Bi4$lVPd__"